import { setAppBusyAction } from '../../../reducers/actions/app'
import { readSingleDevice } from '../helpers'
import { database } from '../../../components/shared/database'
import { functionsBaseUrl } from '../../../components/shared/init-firebase'
import type { DeviceEntity } from './parse-device-data'

export type { DeviceEntity }

/**
 * Refresh device status
 *
 * @param device - Device entity containing uid and ipAddress
 */
export const refreshDeviceStatus = (device: DeviceEntity): void => {
    setAppBusyAction(true)
    window.axios
        .get(`${functionsBaseUrl()}/refreshDeviceData?deviceIp=${device.ipAddress}&deviceUid=${device.uid as string}`)
        .then(() => readSingleDevice(device.uid as string))
        .catch((error: unknown) => {
            console.error(error)
        })
        .finally(() => setAppBusyAction(false))
}

/**
 * On/off device monitored state
 *
 * @param device - Device entity with current isMonitored state
 * @return Firestore update promise
 */
export const toggleIsMonitored = (device: DeviceEntity): Promise<void> => (
    database('device')
        .doc(device.uid as string)
        .update({
            isMonitored: !device.isMonitored,
        })
)

/**
 * Run param on device
 *
 * @param device - Device entity
 * @param address - Register address to trigger
 * @return Firestore add promise
 */
export const toggleTriggerDevice = (device: DeviceEntity, address: string): Promise<unknown> => (
    database('device_writer')
        .add({
            ipAddress: device.ipAddress,
            deviceUid: device.uid as string,
            dbAddress: address,
            dbValue: '1',
        })
)
